import { createSlice } from '@reduxjs/toolkit';
import {
	getProcedureHistoryListQuery,
	addProcedureHistoryThunk,
	getProcedureHistoryThunk,
	updateProcedureHistoryThunk,
	deleteProcedureHistoryThunk,
} from './thunk';

const initialState = {
	procedureHistoryList: [],
	procedureHistoryData: {},
	isLoadingList: false,
	isProcedureHistorySuccess: false,
	error: null,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isGetting: false,
	isGetted: false,
	isGetError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	currentPage: 1,
	totalPages: 1,
	totalRecords: 0,
	itemsPerPage: 10,
	isCloseModal: false,
	requireRefetch: false,
};

const procedureHistorySlice = createSlice({
	name: 'ProcedureHistory',
	initialState,
	reducers: {
		resetProcedureHistoryFlags: state => {
			state.isAdded = false;
			state.isAddError = false;
			state.isUpdated = false;
			state.isUpdateError = false;
			state.isDeleted = false;
			state.isDeleteError = false;
			state.isProcedureHistorySuccess = false;
			state.error = null;
			state.isCloseModal = false;
		},
		resetProcedureHistoryData: state => {
			state.procedureHistoryData = {};
		},
		setRequireRefetch: (state, action) => {
			state.requireRefetch = action.payload;
		},
	},
	extraReducers: builder => {
		builder
			// Get List
			.addCase(getProcedureHistoryListQuery.pending, state => {
				state.isLoadingList = true;
				state.isProcedureHistorySuccess = false;
				state.error = null;
			})
			.addCase(getProcedureHistoryListQuery.fulfilled, (state, action) => {
				state.isLoadingList = false;
				state.isProcedureHistorySuccess = true;
				state.procedureHistoryList = action.payload?.data || [];
				state.currentPage = action.payload?.page || 1;
				state.totalPages = action.payload?.pages || 1;
				state.totalRecords = action.payload?.total || 0;
			})
			.addCase(getProcedureHistoryListQuery.rejected, (state, action) => {
				state.isLoadingList = false;
				state.isProcedureHistorySuccess = false;
				state.error = action.payload;
			})
			// Add
			.addCase(addProcedureHistoryThunk.pending, state => {
				state.isAdding = true;
				state.isAdded = false;
				state.isAddError = false;
				state.error = null;
			})
			.addCase(addProcedureHistoryThunk.fulfilled, state => {
				state.isAdding = false;
				state.isAdded = true;
				state.isAddError = false;
				state.isCloseModal = true;
				state.requireRefetch = true;
			})
			.addCase(addProcedureHistoryThunk.rejected, (state, action) => {
				state.isAdding = false;
				state.isAdded = false;
				state.isAddError = true;
				state.error = action.payload;
			})
			// Get
			.addCase(getProcedureHistoryThunk.pending, state => {
				state.isGetting = true;
				state.isGetted = false;
				state.isGetError = false;
				state.error = null;
			})
			.addCase(getProcedureHistoryThunk.fulfilled, (state, action) => {
				state.isGetting = false;
				state.isGetted = true;
				state.isGetError = false;
				state.procedureHistoryData = action.payload;
			})
			.addCase(getProcedureHistoryThunk.rejected, (state, action) => {
				state.isGetting = false;
				state.isGetted = false;
				state.isGetError = true;
				state.error = action.payload;
			})
			// Update
			.addCase(updateProcedureHistoryThunk.pending, state => {
				state.isUpdating = true;
				state.isUpdated = false;
				state.isUpdateError = false;
				state.error = null;
			})
			.addCase(updateProcedureHistoryThunk.fulfilled, state => {
				state.isUpdating = false;
				state.isUpdated = true;
				state.isUpdateError = false;
				state.isCloseModal = true;
				state.requireRefetch = true;
			})
			.addCase(updateProcedureHistoryThunk.rejected, (state, action) => {
				state.isUpdating = false;
				state.isUpdated = false;
				state.isUpdateError = true;
				state.error = action.payload;
			})
			// Delete
			.addCase(deleteProcedureHistoryThunk.pending, state => {
				state.isDeleting = true;
				state.isDeleted = false;
				state.isDeleteError = false;
				state.error = null;
			})
			.addCase(deleteProcedureHistoryThunk.fulfilled, state => {
				state.isDeleting = false;
				state.isDeleted = true;
				state.isDeleteError = false;
				state.isCloseModal = true;
				state.requireRefetch = true;
			})
			.addCase(deleteProcedureHistoryThunk.rejected, (state, action) => {
				state.isDeleting = false;
				state.isDeleted = false;
				state.isDeleteError = true;
				state.error = action.payload;
			});
	},
});

export const { resetProcedureHistoryFlags, resetProcedureHistoryData, setRequireRefetch } = procedureHistorySlice.actions;

export default procedureHistorySlice.reducer;
